import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap'

import CustomButton from '../../CustomButton'
import { toastr } from 'react-redux-toastr'

const AddProfileModal = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.fleetConfigurationContainer.addProfileModal' });
	const { onHide, profiles, addProfile, company } = props;

	const isProd = location.hostname === 'fleet.roscolive.com';
	const DV7access = (!isProd && !['S3 buckets partner'].includes(company.partner)) || (isProd && (['DV7 Rosco Testing'].includes(company.partner) || [2101, 2774, 2565].includes(company.company_id)));

	const [deviceType, setDeviceType] = useState("dv6")
	const [selectedProfile, setSelectedProfile] = useState(profiles.find(profile => profile.name === 'Default'))

	const defaultProfile = profiles.find(profile => profile.name === 'Default')

	const profilesForDeviceType = deviceType === 'dv7'
		? profiles.filter(profile => profile.name === 'Default')
		: profiles

	const selectNewProfile = (e) => {
		const newProfile = profiles.find(profile => profile.id.toString() === e.target.value)
		setSelectedProfile(newProfile)
	}

	const handleDeviceTypeChange = (e) => {
		const newType = e.target.value
		setDeviceType(newType)
		if (newType === 'dv7') {
			setSelectedProfile(defaultProfile)
		}
	}

	const onCreateClick = () => {
		const { name, configuration, configurationdv6, configurationdv7 } = selectedProfile

		if (deviceType === 'dv4' && (!configuration || configuration.length < 10)) {
			toastr.error(t('DV4configurationEmpty', { name: `"${name}"` }))
			return
		}
		if (deviceType === 'dv6' && (!configurationdv6 || configurationdv6.length < 10)) {
			toastr.error(t('DV6configurationEmpty', { name: `"${name}"` }))
			return
		}
		if (deviceType === 'dv7' && (!configurationdv7 || configurationdv7.length < 10)) {
			toastr.error(t('DV7configurationEmpty', { name: `"${name}"` }))
			return
		}

		addProfile(selectedProfile.name, deviceType)
	}

	return (
		<Modal
			show
			onHide={onHide}
			className="modal-lg-size"
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-lg">{t('titleAddFleetProfile')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className='config-modal-body add-profile-modal'>
					<label>{t('textSelectFleetProfile')}</label>
					<div className="text-center">
						<div className='device-type-select'>
							<select
								className="rosco-select deviceType"
								name="selected_device_type"
								onChange={handleDeviceTypeChange}
								value={deviceType}
							>
								<option value='dv6'>DV6</option>
								{DV7access && <option value='dv7'>DV7</option>}
								<option value='dv4'>DV4</option>
							</select>
						</div>
						<select name="profile-select" id="profile-select" className="rosco-select" value={selectedProfile.id} onChange={selectNewProfile}>
							{profilesForDeviceType.map((item, index) =>
								<option key={index} value={item.id} className="menu-item">{item.name}</option>
							)}
						</select>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<CustomButton variant="primary" onClick={onCreateClick}>{t('btnCreateNewProfile')}</CustomButton>
			</Modal.Footer>
		</Modal>
	)
}

export default AddProfileModal;
